import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';

gsap.registerPlugin(ScrollTrigger);

export default class Hero {
  constructor(element) {
    this.element = element;
    this.heroImage = element.querySelector('.js-hero-img-container');
    this.img = this.heroImage.querySelector('.js-hero-img');

    this.init();
  }

  init() {
    const animation = gsap
      .timeline()
      .to(this.heroImage, {
        '--start': '50%',
        '--end': '50%',
      })
      .to(
        this.img,
        {
          scale: 1.05,
        },
        '<'
      );

    ScrollTrigger.create({
      animation: animation,
      trigger: this.heroImage,
      scrub: 0.5,
      start: 'top top',
      end: '80% top',
    });
  }
}
